import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { ArrowExpandIcon, ShareIcon } from '@calendly/ui/components/icons';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import PropTypes from 'prop-types';
import { IconAiSparkleMiniGradient } from '../assets';
const recapSectionCss = "rb3brm9";
const recapHeaderCss = "rrnvh6t";
const recapBadgeCss = "r1b65m9";
const recapContentCss = "r145kja8";
const truncatedTextCss = "t5udn4d";
const buttonContainerCss = "b1n2pvxs";

/**
 * RecapSummarySection component displays a recap summary with AI badge and action buttons.
 *
 * This component shows a summary text with an AI Sparkle badge and provides buttons
 * to view the full recap and share it.
 *
 * @param {Object} props - Component props
 * @param {string} props.summary - The recap summary text
 * @param {string} [props.recapId] - The ID of the recap for navigation
 * @param {Function} [props.onShareClick] - Handler for share button click
 *
 * @returns {JSX.Element|null} The recap summary section or null if no summary
 *
 * @example
 * ```jsx
 * <RecapSummarySection
 *   summary="At vero eos et accusamus et iusto odio dignissimos..."
 *   recapId="abc123"
 *   onShareClick={handleShareClick}
 * />
 * ```
 */
export const RecapSummarySection = ({
  summary = '',
  recapId = '',
  onShareClick = () => {}
}) => {
  const handleViewRecapClick = () => {
    if (recapId) {
      window.open(`/app/tracked_meetings/${recapId}`, '_blank', 'noopener,noreferrer');
    }
  };
  if (!summary) {
    return null;
  }
  return <div className={recapSectionCss}>
      <div className={recapHeaderCss}>
        <div className={recapBadgeCss}>
          <IconAiSparkleMiniGradient size={16} />
        </div>
        <TitleText size="x-small">{I18n.t('publisher.agent_hub.recap_hover_card.recap_summary')}</TitleText>
      </div>
      <div className={recapContentCss}>
        <BodyText size="medium">
          <span className={truncatedTextCss}>
            {summary}
          </span>
        </BodyText>
        <div className={buttonContainerCss}>
          <Button decoration="secondary-outline" size="small" onClick={handleViewRecapClick}>
            <ArrowExpandIcon />
            {I18n.t('publisher.agent_hub.recap_hover_card.view_recap')}
          </Button>
          <Button decoration="ghost" size="small" onClick={onShareClick}>
            <ShareIcon />
            {I18n.t('publisher.agent_hub.recap_hover_card.share_recap')}
          </Button>
        </div>
      </div>
    </div>;
};
RecapSummarySection.propTypes = {
  summary: PropTypes.string,
  recapId: PropTypes.string,
  onShareClick: PropTypes.func
};

require("./RecapSummarySection.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RecapSummarySection.js");